<template>
  <PageViewContainer>
    <v-card class="mx-auto my-12" width="100%">
      <v-card-title>{{
          $store.state.text.pages.register.pageTitle
        }}
      </v-card-title>
      <v-card-subtitle>
        <v-alert dismissible color="success" v-if="showAlert">
          {{ $store.state.text.pages.register.successMessage }}
        </v-alert>
      </v-card-subtitle>

      <v-card-text v-if="!showAlert">
        <v-form ref="form" model="valid">
          <v-text-field
            v-model="user.username"
            :counter="100"
            :label="$store.state.text.fields.username"
            required
            class="text-uppercase"
            :error-messages="errors.username"
          ></v-text-field>
          <v-text-field
            v-model="user.email"
            :label="$store.state.text.fields.email"
            required
            :rules="emailRules"
            class="text-uppercase"
            :error-messages="errors.email"
          ></v-text-field>
          <v-text-field
            v-model="user.password"
            :label="$store.state.text.fields.password"
            required
            :counter="100"
            class="text-uppercase"
            :error-messages="errors.password"
            type="password"
          ></v-text-field>
          <v-text-field
            v-model="user.passwordRepeat"
            :label="$store.state.text.fields.passwordRepeat"
            :rules="passwordRepeatRules"
            required
            :counter="100"
            class="text-uppercase"
            type="password"
          ></v-text-field>
          <v-checkbox
            v-model="user.agreedForNewsletter"
            :label="$store.state.text.fields.agreedForNewsletter"
          ></v-checkbox>
          <v-checkbox
            v-model="user.acceptRule"
            :label="$store.state.text.fields.acceptRule"
            :rules="requiredRules"
            required
          ></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center" v-if="!showAlert">
        <v-btn class="mr-4" @click="recaptcha" color="primary" small>
          {{ $store.state.text.buttons.createUser }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </PageViewContainer>
</template>

<script>
import Axios from '@/core/Axios';
import PageViewContainer from '@/components/Partials/PageViewContainer.vue';
import { state } from '../../store/index';

export default {
  name: 'UserRegister',
  components: { PageViewContainer },
  data() {
    return {
      showAlert: false,
      valid: false,
      user: {
        username: '',
        email: '',
        password: '',
        passwordRepeat: '',
        acceptRule: false,
        agreedForNewsletter: false,
        recaptchaToken: null,
      },
      errors: [],
      emailRules: [
        (v) => !!v || state.text.fields.validation.required,
        (v) => /.+@.+/.test(v) || state.text.fields.validation.emailNotValid,
      ],
      requiredRules: [
        (v) => !!v || state.text.fields.validation.required,
      ],
      passwordRepeatRules: [
        (v) => v === this.user.password || state.text.fields.validation.passwordNotMatch,
      ],
      axios: new Axios(),
      host: process.env.VUE_APP_API_HOST,
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.user.acceptRule) {
        this.axios.makeCall('POST', 'norbit/customer', this.user)
          .then((response) => {
            if (response) {
              this.showAlert = true;
            }
          })
          .catch((error) => {
            this.errors = error.errors;
          });
      }
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login');
      if (token) {
        this.user.recaptchaToken = token;
        this.submit();
      }
    },
  },
};
</script>

<style scoped>
</style>
